import React from 'react';
import { useTranslation } from 'react-i18next';
import { useContentCheck } from '../../../../queries/wallPreview';

/**
 * Smart Template Engine — Preview System (Phase 3D): Content Verification.
 *
 * Reads /content-check (scheduled vs actual) and surfaces a mismatch — the scariest
 * failure ("wrong menu live"). Polls every 20s. Read-only.
 *   verdict: ok | mismatch | no_schedule | stopped
 */
export default function ContentVerificationBanner({ wallId, dotOnly = false }) {
  const { t } = useTranslation();
  const { data: check } = useContentCheck(wallId);
  const verdict = check?.verdict;

  const color = verdict === 'mismatch' ? 'var(--pp-danger)'
    : verdict === 'ok' ? 'var(--pp-success)'
      : 'var(--pp-text-secondary)';

  if (dotOnly) {
    if (!verdict || verdict === 'stopped') return null;
    return <span title={t(`video_wall.verify.${verdict}`)} style={{ width: 9, height: 9, borderRadius: '50%', background: color, display: 'inline-block' }} />;
  }

  if (verdict !== 'mismatch') return null; // only shout on a real mismatch
  return (
    <div className="p-3 mb-3 d-flex align-items-center gap-2" style={{
      borderRadius: 'var(--pp-radius-lg)', background: 'rgba(220,53,69,0.12)',
      border: '1px solid var(--pp-danger)' }}>
      <i className="pi pi-exclamation-triangle" style={{ color: 'var(--pp-danger)', fontSize: 20 }} />
      <div className="small">
        <strong style={{ color: 'var(--pp-danger)' }}>{t('video_wall.verify.mismatch_title')}</strong>
        <div style={{ color: 'var(--pp-text-secondary)' }}>
          {t('video_wall.verify.mismatch_detail', { playing: check?.actual?.name || '—', scheduled: check?.scheduled?.name || '—' })}
        </div>
      </div>
    </div>
  );
}
